<template>
  <div>
    <component
      v-for="(block, index) in blocks"
      v-bind:is="'v-' + block.acf_fc_layout"
      v-bind="block"
      :key="block.acf_fc_layout + ':' + index"
    />
  </div>
</template>

<script>
import VTextTrioOfImages from "./TextTrioOfImages.vue";
import VTextText from "./TextText.vue";
import VTextImage from "./TextImage.vue";
import VTextImageContain from "./TextImageContain.vue";
import VTextImageFullWidth from "./TextImageFullWidth.vue";
import VTextVideoFullWidth from "./TextVideoFullWidth.vue";
import VImageFull from "./ImageFull.vue";
import VImageContain from "./ImageContain.vue";
import VText from "./Text.vue";
import VQuote from "./Quote.vue";
import VAccordion from "./Accordion.vue";
import VLinkList from "./LinkList.vue";
import VCards from "./Cards.vue";
import VImageImage from "./ImageImage.vue";
import VSpotlight from "./Spotlight.vue";
import VVideo from "./Video.vue";
import VContactForm from "./ContactForm.vue";
import VPageCards from "./PageCards.vue";
import VMap from "./map/Map.vue";

export default {
  props: {
    blocks: Array,
  },
  components: {
    VTextTrioOfImages,
    VTextImage,
    VTextImageContain,
    VTextImageFullWidth,
    VTextVideoFullWidth,
    VImageFull,
    VImageContain,
    VText,
    VTextText,
    VQuote,
    VAccordion,
    VLinkList,
    VCards,
    VImageImage,
    VSpotlight,
    VVideo,
    VContactForm,
    VPageCards,
    VMap,
  },
};
</script>

<style lang="scss" scoped></style>
